import { CANCELED, CANCELLED, DELIVERED, GIFT_CLAIMED, GIFT_EXPIRED, SHIPPED } from './reports';

export const ENGAGEMENT_LABEL = 'Send';

export const PHYSICAL_NON_CANCELING_STATUSES = [CANCELED, SHIPPED, DELIVERED];
export const DIGITAL_NON_CANCELING_STATUSES = [GIFT_CLAIMED, GIFT_EXPIRED, CANCELLED];
